import {
  IconButton
} from "@mui/material"
import {
  Dispatch,
  SetStateAction,
  useState
} from "react"
import { useTheme } from "../providers/theme"
import {
  CheckBoxRounded,
  CheckBoxOutlineBlankRounded
} from '@mui/icons-material'

export function CustomSelect({
  items,
  multiple,
  nonEmpty = false,
  setFunction
}: {
  items: {value: string, selected:  boolean}[],
  multiple: boolean,
  nonEmpty?: boolean,
  setFunction: Dispatch<SetStateAction<string>>
}) {
  const {mode} = useTheme()
  const [options, setOptions] = useState<{value: string, selected: boolean}[]>(items)

  return (
    <div
      style={{
        width: "100%",
        height: "auto",
        maxHeight: "16em",
        overflowY: "auto",
        padding: ".5em",
        margin: ".5em",
        backgroundColor: mode === 'light' ? "#F6F6F6" : "#252525"
      }}
    >
      {
        options.map((option, index) =>
          <IconButton
            tabIndex={0}
            aria-labelledby={`${option.value}`}
            aria-describedby={`select ${option.value}`}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              fontSize: "1em",
              gap: ".5em",
              width: "100%",
              paddingInline: "1em",
              paddingBlock: ".5em",
              marginBottom: `${index !== options.length - 1 ? ".5em" : "0"}`,
              borderRadius: "10px",
              boxShadow: mode === 'light' ? "0px 3px 12px -1px rgba(0, 0, 0, 0.2)" : "0px 3px 12px -1px rgba(0, 0, 0, 0.5)",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: mode === 'light' ? "#E6E6E6" : "#353535",
              }
            }}
            onClick={() => {
              let newOptions = [...options]
              if (!multiple) {
                newOptions.map((option) => option.selected = false)
              } else {
                if (option.value.toLowerCase() === "all") {
                  for (let option of newOptions) {
                    if (option.value.toLowerCase() !== "all") {
                      option.selected = true
                    }
                  }
                } else {
                  let allSelected = true
                  for (let option of newOptions) {
                    if ((option.value.toLowerCase() !== "all" && option.value.toLowerCase() !== newOptions[index].value.toLowerCase() && option.selected === false) ||
                        (option.value.toLowerCase() === newOptions[index].value.toLowerCase() && option.selected === true)) {
                      allSelected = false
                      break
                    }
                  }
                  if (!allSelected) {
                    for (let option of newOptions) {
                      if (option.value.toLowerCase() === "all") {
                        option.selected = false
                        break
                      }
                    }
                  } else {
                    for (let option of newOptions) {
                      if (option.value.toLowerCase() === "all") {
                        option.selected = true
                        break
                      }
                    }
                  }
                }
              }
              newOptions[index].selected = !newOptions[index].selected
              setOptions(newOptions)
              if (multiple) {
                let selectedOptionsArray: string[] = []
                options.map(option => option.selected && selectedOptionsArray.push(option.value))
                let optionsString = ""
                let allOptionIndex = selectedOptionsArray.map(option => option.toLowerCase()).indexOf("all")
                if (allOptionIndex > -1) {
                  selectedOptionsArray.splice(allOptionIndex, 1)
                }
                optionsString = selectedOptionsArray.join(';')
                if (nonEmpty && selectedOptionsArray.length === 0) {
                  newOptions[index].selected = true
                  optionsString = newOptions[index].value
                }
                setFunction(optionsString)
                return;
              }
              setFunction(newOptions[index].value)
            }}
            key={index}
          >
            {
              option.selected ?
                <CheckBoxRounded sx={{ color: "#85d201" }} />
              :
                <CheckBoxOutlineBlankRounded />
            }
            <p
              style={{
                userSelect: "none",
                fontSize: "1em !important"
              }}
            >
              {option.value}
            </p>
          </IconButton>
        )
      }
    </div>
  )
}